export const environment = {
  production: true,
  apiRootUrl: 'https://asia-northeast1-facere-facility-dev.cloudfunctions.net',
  firebase: {
    apiKey: "AIzaSyDQxOYtkLtTDMcEGmEWyCKIJMmWXwOXfRw",
    authDomain: "facere-facility-dev.firebaseapp.com",
    databaseURL: "https://facere-facility-dev.firebaseio.com",
    projectId: "facere-facility-dev",
    storageBucket: "facere-facility-dev.appspot.com",
    messagingSenderId: "265662701993",
    appId: "1:265662701993:web:f28b3a0c72a636c59124b8",
    measurementId: "G-DJX09QQFLL"
  },
  googleAuthClientId: '265662701993-egpt4cm1cac5gu542g2j7pmnlnfgkbo1.apps.googleusercontent.com',

  //URL
  devUrl: "https://facere-facility-dev.web.app/",
  prodUrl: "https://facere-facility-prod.web.app/",
  googleMapsApiKey: 'AIzaSyDdUx-5ZyhYCapn7k-0KXPmbHUD5pr69YE',
  qrBaseUrl: 'https://facere-facility-dev-qrreader.web.app/',
};
